import type { KambiValidReward } from '@mobi/api-types/kambi/player/reward'

export function getKambiRewardId(reward: KambiValidReward): number | undefined {
  if (reward.isGroupReward && reward.groupRewardId) return reward.groupRewardId
  if (reward.rewardId) return reward.rewardId

  return undefined
}
